/**
 * The crest a pick-stats screen draws for one side (specs/champions-league AC-10.6).
 *
 * National-team competitions get the flag they always got. Club competitions get the kit,
 * and must: the server derives its country code from `team.country`, which for a club
 * resolves to a perfectly valid code — so the "no code, no crest" guard never fires and a
 * club would otherwise be shown wearing its country's flag.
 *
 * The kit is rendered through `CountryFlag`'s existing `kitFallback` path (empty code =
 * no URL = fallback), which already sizes a `SoccerKit` per flag size. No new styling.
 */

import React from 'react';
import type { TeamKitConfig } from '../../../constants/teamKitColors';
import { CountryFlag } from '../CountryFlag/CountryFlag';

export interface PickStatsTeamCrestProps {
  countryCode: string | null;
  /** Non-null in kit mode. Wins over `countryCode` whenever present. */
  kit: TeamKitConfig | null;
  size?: 'default' | 'compact' | 'mini';
  accessibilityLabel?: string;
  testID?: string;
}

export const PickStatsTeamCrest: React.FC<PickStatsTeamCrestProps> = ({
  countryCode,
  kit,
  size = 'default',
  accessibilityLabel,
  testID,
}) => {
  if (kit != null) {
    return (
      <CountryFlag
        countryCode=""
        kitFallback={kit}
        size={size}
        accessibilityLabel={accessibilityLabel}
        testID={testID}
      />
    );
  }
  if (!countryCode) return null;
  return (
    <CountryFlag
      countryCode={countryCode}
      size={size}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
    />
  );
};
